// extracted by mini-css-extract-plugin
export var drawerPaper = "_2a-0";
export var itemCard = "_2a-1";
export var itemImage = "_2a-2";